import { Button } from 'antd';

import handScanning from 'assets/images/hand-phone.svg';
import { Html5QrcodeScannerState } from 'html5-qrcode';

import styles from './styles.module.css';

type StartScannerProps = {
  cameraId: string | null;
  scannerState: Html5QrcodeScannerState | null;
  startScanner: () => void;
};

const StartScanner = ({ cameraId, scannerState, startScanner }: StartScannerProps) => {
  if (!cameraId || scannerState) {
    return null;
  }

  return (
    <div className={styles.container}>
      <img src={handScanning} alt='Hand scanning QR Code' />
      <Button onClick={startScanner} type='primary' className={styles.button}>
        <span className={styles.text}>Ligar Câmera</span>
      </Button>
    </div>
  );
};

export default StartScanner;
